import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api } from "@/lib/apiClient";
import Seo from "@/components/Seo";

export default function Destinations() {
  const [dests, setDests] = useState([]);
  useEffect(() => { api.get("/destinations", { params: { published: true } }).then((r) => setDests(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <Seo title="Destinations" description="Explore the destinations VacanzaGo knows intimately — Kashmir, Ladakh, Uttarakhand, Himachal, Goa, Varanasi and more." />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-14">
          <p className="eyebrow">Where we travel</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">Destinations we know intimately</h1>
          <p className="mt-4 text-lg text-[#553204]">Places we've returned to, season after season.</p>
        </Reveal>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {dests.map((d, i) => (
            <Reveal key={d.slug} delay={(i % 3) * 80}>
              <Link to={`/destinations/${d.slug}`} data-testid={`destination-card-${d.slug}`} className="group relative block h-80 rounded-md overflow-hidden img-zoom">
                <img src={d.hero_image} alt={d.name} className="h-full w-full object-cover" loading="lazy" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(42,24,8,0) 35%, rgba(42,24,8,0.85) 100%)" }} />
                <div className="absolute bottom-0 p-6 w-full">
                  <p className="text-[#F49E1A] text-xs uppercase tracking-widest">{d.region}</p>
                  <h3 className="font-display text-3xl text-white mt-1">{d.name}</h3>
                  <p className="text-[#F9EFE1]/80 text-sm mt-1 italic font-display text-lg">{d.tagline}</p>
                  <span className="mt-3 inline-flex items-center gap-2 text-sm text-white/90 opacity-0 group-hover:opacity-100 transition-opacity">Explore <ArrowRight size={15} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
